// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3h0UL","visuallyhidden":"_2ZO3h","hide-text":"_2Vt5q","center":"_1tn6N","noprint":"_2764Y","carousel":"vIOJJ","slideContainer":"qpvc7","slideContainerViewport":"_3L7Yk","slide":"_3N5--","slideItemWrapper":"_2ZMJP","changeSlideButton":"_1dnSr","changeSlideButtonDisabled":"_3E_9u"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-carousel/styles/sports.scss
 ** module id = 343
 ** module chunks = 2
 **/